// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

/*=============================================== Custom styles for Kendo input ============================================*/
.kc-input {
  border: none;
  border-radius: 8px;
  height: 40px;
  padding-inline: 12px !important;
}

.kc-input:focus {
  border-color: #9ee5f7;
  padding-left: 12px;
  padding-right: 8px;
  box-shadow: 0 0 0 2px #65d0eb;
  outline: 0;
}

/* Placeholder color for Kendo Input */
.kc-input::placeholder {
  color: #aab1bf;
  /* Adjust the placeholder color as needed */
}

.kc-input-container {
  border: 0.4px solid gainsboro;
  display: flex;
  border-radius: 8px;
}

.kc-input-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  padding-right: 12px;
  padding-left: 12px;
  cursor: pointer;
}

/*=============================================== Custom styles for Kendo Button ============================================*/
.k-button.kc-button {
  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;
  background-color: transparent !important;
  color: #fff !important;
  width: 100%;
  font-weight: 600;
  padding: 10px;
  padding-left: 24px;
  padding-right: 24px;
  font-size: medium;
  border-radius: 10px;
  border: 1px solid rgb(249, 245, 245) !important;
}

.k-button.kc-button:focus {
  outline: none;
}

.k-button.kc-button:hover,
.k-button.kc-button.k-hover {
  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;
  background-color: transparent !important;
  transform: scale(1.02);
  transition: transform 0.2s ease-in, background 0.2s ease-out;
}

.k-button.kc-button:active,
.k-button.kc-button.k-active {
  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;
  background-color: transparent !important;
}

.k-button.kc-button:disabled,
.k-button.kc-button.k-disabled {
  background: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

.kc-button .k-button-text {
  display: flex;
  align-items: center;
}

/* =================================================== checkbox style ============================================================= */
.kendo-custom-checkbox {
  color: #1cb8fb;
  /* Default color for the checkbox */
}

.k-checkbox:checked {
  border-color: rgb(63 58 58);
  background-color: rgb(63 58 58);
}

.k-checkbox-md {
  width: 20px;
  height: 20px;
}

.k-checkbox:checked:focus {
  box-shadow: 0 0 0 2px rgba(61, 59, 59, 0.3);
}

/* ====================================================== Required Error style ======================================================== */

.form-error {
  font-weight: 400;
  font-size: 15px;
  line-height: normal;
  color: #f54e4e;
  text-align: justify;
  padding-left: 4px;
  padding-top: 5px;
  letter-spacing: normal;
}

/* ========================================================= meadiaquery for login signup ================================================= */

@media (min-width: 1400px) {
  .registercard {
    max-width: 80%;
  }
}

.registercard {
  margin: 60px auto 20px;
}

.cancel-button {
  position: absolute;
  right: 25px;
  top: 25px;
  background: none;
  border-radius: 10px;
  border: none;
  font-size: 30px;
  cursor: pointer;
}

/* ========================================================= Device management ================================================= */

.device-image {
  width: 30px;
  cursor: pointer;
}

.image-container {
  width: 30px;
  position: relative;
  cursor: pointer;
  transition: transform 0.5s ease;
}

.rotate-180 {
  animation: rotateAnimation 1s linear infinite;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(180deg);
  }
}

/* ===================================================== Terms and conditions style ============================================= */

.terms-tittle {
  margin-top: 10pt;
  margin-bottom: 0pt;
  text-align: center;
  line-height: normal;
  widows: 0;
  orphans: 0;
  font-size: 16pt;
}

.last-updated {
  margin-top: 10pt;
  margin-bottom: 0pt;
  line-height: normal;
  widows: 0;
  orphans: 0;
  font-size: 16pt;
}

.terms-paragraph {
  margin-top: 0pt;
  margin-bottom: 0pt;
  text-align: justify;
  line-height: normal;
  widows: 0;
  orphans: 0;
  font-size: 16pt;
}

.space-span {
  font-family: "Times New Roman";
}

.bullet-pints-description {
  margin-left: 27.58pt;
  text-align: justify;
  line-height: normal;
  widows: 0;
  orphans: 0;
  padding-left: 8.42pt;
  font-family: serif;
  font-size: 16pt;
}

/* ========================================================= Custom Date time picker =================================================== */
.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker-popper {
  z-index: 10 !important;
}
.react-datepicker-wrapper {
  width: 100%;
}
.custom-date-picker {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 8px;
}

.custom-date-picker:focus-visible {
  outline: 1px solid #1cb8fb !important;
}

.energy-icon {
  width: 40px;
}

.flex-Dropdown {
  background-color: white;
}

.custom-dropdown-tree {
  width: 100%;
  overflow: visible;
  z-index: 2;
  padding: 5px;
  border-radius: 8px;
  background-color: #fff;
}

.location-wrap .k-treeview-group {
  text-wrap: auto;
}

.k-animation-container-shown {
  z-index: 10003 !important;
}

.k-dialog-wrapper {
  z-index: 10003 !important;
}

.custom-select {
  padding: 10px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  border: 1px solid #d0d0d0;
  color: #7e7e7e;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.custom-select:focus {
  border-color: #1cb8fb;
  border-width: 2px;
}

.custom-select:focus-visible {
  outline: #1cb8fb;
}

.custom-select option {
  background-color: #fff;
  padding: 5px;
  font-size: 14px;
}

.c-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.c-select {
  padding: 10px;
  padding-left: 10px;
  padding-right: 35px;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  min-width: 150px;
  height: 42px;
  border: 1px solid #d0d0d0;
  color: #605f5fdd;
  font-size: 14px;
  appearance: none;
  cursor: pointer;
}

/* Adds a custom dropdown icon */
.c-select-wrapper::after {
  content: "▼"; /* Unicode down arrow */
  font-size: 12px;
  color: #888;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.c-select:focus {
  border-color: #1cb8fb;
  border-width: 2px;
  outline: none;
}

.c-select option {
  background-color: #fff;
  color: #333;
}

.flex-multi-select {
  font-size: small;
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
}
.flex-multi-select:focus {
  border-color: #1cb8fb !important;
  border-width: 2px;
}
.css-1pahdxg-control:hover {
  border-color: #1cb8fb !important;
}

.css-1pahdxg-control {
  box-shadow: 0 0 0 2px #9ee5f7 !important;
  border-color: #1cb8fb !important;
}

.rounded-pricing-img {
  width: 70px;
  height: 70px;
  border-radius: 24%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ecf3ff;
}

.custom-upload-button {
  border: 1px dashed blue;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  background-color: #f9f9f9;
}

.plan-badge {
  background-color: #c1fac1;
  border-radius: 6px;
  padding: 8px;
  color: green;
  font-weight: 400;
}

.cus-hr {
  width: 150px;
}

.ticket-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid grey;
  border-radius: 5px;
  cursor: pointer;
}
.c-title {
  color: #0088ff;
}

.min-guage {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  padding: 0 2px;
}

.home-btn {
  width: 60px;
  height: 60px;
  background-color: #fff !important;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.home-btn:hover {
  transform: scale(1.15);
  background-color: #0277bd;
}
.c-notification-form-control .c-radio-margin {
  margin-left: 16px;
}

@media (min-width: 768px) {
  .c-notification-form-control .c-radio-margin {
    margin-left: 0px;
  }
}
.c-notification-form-control .c-radio-margin {
  margin-left: 0px;
}

.c-pl {
  padding-left: 20px;
}

.c-img {
  width: 100%;
  border-radius: 8px;
}

.c-choose-li {
  position: relative;
  padding-left: 40px;
  margin-bottom: 16px;
  font-size: 1.25rem;
  line-height: 1.6;
  color: #344767;
  transition: all 0.3s ease;
  cursor: default;
}

.c-choose-li:hover {
  color: #17ad37;
  transform: translateX(5px);
}

.c-choose-icon {
  position: absolute;
  left: 0;
  top: 4px;
  font-size: 1.5rem;
  color: #17ad37;
}

.logo-slide-1 {
  opacity: 1;
  transform: none;
  max-width: 100px;
  position: absolute;
  right: 20px;
  bottom: 10px;
}
@media (max-width: 768px) {
  .slick-slide img.logo-slide-1 {
    display: none;
  }
}

.list-none {
  list-style-type: none;
}

.signature-canvas {
  border: 1px solid #ccc;
  background-color: #fff;
  display: block;
}
/* fullcalendar styles */

.fc-toolbar button {
  background-color: #1976d2;
  color: white;
  border-radius: 4px;
  padding: 6px 12px;
  margin-right: 6px;
  border: none;
  font-weight: bold;
}

.fc-toolbar .fc-toolbar-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #444;
}

.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 16px;
}

.event-danger {
  color: red;
}

.event-green {
  color: green;
}

.c-table {
  border-collapse: separate;
   border-spacing: 0 8px;
}

.c-table-head {
  background: rgba(0,0,0,0.02);
  border-bottom: 1px solid #c6c6c6;
}

.c-table-p-0{
  padding: 4px;
}

.c-video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height:100%;
  object-fit: contain ;
  background: black;
}

.activity-link {
  width: -moz-fit-content;
  width: fit-content;
  text-decoration: none;  
}`, "",{"version":3,"sources":["webpack://./src/assets/theme/components/styles.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,6HAA6H;AAC7H;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,8HAA8H;AAC9H;EACE,kEAAkE;EAClE,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kEAAkE;EAClE,wCAAwC;EACxC,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;;EAEE,kEAAkE;EAClE,wCAAwC;AAC1C;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qIAAqI;AACrI;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,yIAAyI;;AAEzI;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6IAA6I;;AAE7I;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,kIAAkI;;AAElI;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mIAAmI;;AAEnI;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0IAA0I;AAC1I;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,YAAY,EAAE,uBAAuB;EACrC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,0CAA0C;EAC1C,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;AACA,wBAAwB;;AAExB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;GACxB,qBAAqB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":["/* styles.css */\n\n/*=============================================== Custom styles for Kendo input ============================================*/\n.kc-input {\n  border: none;\n  border-radius: 8px;\n  height: 40px;\n  padding-inline: 12px !important;\n}\n\n.kc-input:focus {\n  border-color: #9ee5f7;\n  padding-left: 12px;\n  padding-right: 8px;\n  box-shadow: 0 0 0 2px #65d0eb;\n  outline: 0;\n}\n\n/* Placeholder color for Kendo Input */\n.kc-input::placeholder {\n  color: #aab1bf;\n  /* Adjust the placeholder color as needed */\n}\n\n.kc-input-container {\n  border: 0.4px solid gainsboro;\n  display: flex;\n  border-radius: 8px;\n}\n\n.kc-input-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  padding-right: 12px;\n  padding-left: 12px;\n  cursor: pointer;\n}\n\n/*=============================================== Custom styles for Kendo Button ============================================*/\n.k-button.kc-button {\n  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;\n  background-color: transparent !important;\n  color: #fff !important;\n  width: 100%;\n  font-weight: 600;\n  padding: 10px;\n  padding-left: 24px;\n  padding-right: 24px;\n  font-size: medium;\n  border-radius: 10px;\n  border: 1px solid rgb(249, 245, 245) !important;\n}\n\n.k-button.kc-button:focus {\n  outline: none;\n}\n\n.k-button.kc-button:hover,\n.k-button.kc-button.k-hover {\n  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;\n  background-color: transparent !important;\n  transform: scale(1.02);\n  transition: transform 0.2s ease-in, background 0.2s ease-out;\n}\n\n.k-button.kc-button:active,\n.k-button.kc-button.k-active {\n  background: linear-gradient(to right, #1cb8fb, #0067fa) !important;\n  background-color: transparent !important;\n}\n\n.k-button.kc-button:disabled,\n.k-button.kc-button.k-disabled {\n  background: #ccc !important;\n  color: #666 !important;\n  cursor: not-allowed;\n}\n\n.kc-button .k-button-text {\n  display: flex;\n  align-items: center;\n}\n\n/* =================================================== checkbox style ============================================================= */\n.kendo-custom-checkbox {\n  color: #1cb8fb;\n  /* Default color for the checkbox */\n}\n\n.k-checkbox:checked {\n  border-color: rgb(63 58 58);\n  background-color: rgb(63 58 58);\n}\n\n.k-checkbox-md {\n  width: 20px;\n  height: 20px;\n}\n\n.k-checkbox:checked:focus {\n  box-shadow: 0 0 0 2px rgba(61, 59, 59, 0.3);\n}\n\n/* ====================================================== Required Error style ======================================================== */\n\n.form-error {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: normal;\n  color: #f54e4e;\n  text-align: justify;\n  padding-left: 4px;\n  padding-top: 5px;\n  letter-spacing: normal;\n}\n\n/* ========================================================= meadiaquery for login signup ================================================= */\n\n@media (min-width: 1400px) {\n  .registercard {\n    max-width: 80%;\n  }\n}\n\n.registercard {\n  margin: 60px auto 20px;\n}\n\n.cancel-button {\n  position: absolute;\n  right: 25px;\n  top: 25px;\n  background: none;\n  border-radius: 10px;\n  border: none;\n  font-size: 30px;\n  cursor: pointer;\n}\n\n/* ========================================================= Device management ================================================= */\n\n.device-image {\n  width: 30px;\n  cursor: pointer;\n}\n\n.image-container {\n  width: 30px;\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.5s ease;\n}\n\n.rotate-180 {\n  animation: rotateAnimation 1s linear infinite;\n}\n\n@keyframes rotateAnimation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(180deg);\n  }\n}\n\n/* ===================================================== Terms and conditions style ============================================= */\n\n.terms-tittle {\n  margin-top: 10pt;\n  margin-bottom: 0pt;\n  text-align: center;\n  line-height: normal;\n  widows: 0;\n  orphans: 0;\n  font-size: 16pt;\n}\n\n.last-updated {\n  margin-top: 10pt;\n  margin-bottom: 0pt;\n  line-height: normal;\n  widows: 0;\n  orphans: 0;\n  font-size: 16pt;\n}\n\n.terms-paragraph {\n  margin-top: 0pt;\n  margin-bottom: 0pt;\n  text-align: justify;\n  line-height: normal;\n  widows: 0;\n  orphans: 0;\n  font-size: 16pt;\n}\n\n.space-span {\n  font-family: \"Times New Roman\";\n}\n\n.bullet-pints-description {\n  margin-left: 27.58pt;\n  text-align: justify;\n  line-height: normal;\n  widows: 0;\n  orphans: 0;\n  padding-left: 8.42pt;\n  font-family: serif;\n  font-size: 16pt;\n}\n\n/* ========================================================= Custom Date time picker =================================================== */\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker-popper {\n  z-index: 10 !important;\n}\n.react-datepicker-wrapper {\n  width: 100%;\n}\n.custom-date-picker {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-left: 8px;\n}\n\n.custom-date-picker:focus-visible {\n  outline: 1px solid #1cb8fb !important;\n}\n\n.energy-icon {\n  width: 40px;\n}\n\n.flex-Dropdown {\n  background-color: white;\n}\n\n.custom-dropdown-tree {\n  width: 100%;\n  overflow: visible;\n  z-index: 2;\n  padding: 5px;\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.location-wrap .k-treeview-group {\n  text-wrap: auto;\n}\n\n.k-animation-container-shown {\n  z-index: 10003 !important;\n}\n\n.k-dialog-wrapper {\n  z-index: 10003 !important;\n}\n\n.custom-select {\n  padding: 10px;\n  padding-left: 5px;\n  padding-right: 5px;\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  border: 1px solid #d0d0d0;\n  color: #7e7e7e;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n\n.custom-select:focus {\n  border-color: #1cb8fb;\n  border-width: 2px;\n}\n\n.custom-select:focus-visible {\n  outline: #1cb8fb;\n}\n\n.custom-select option {\n  background-color: #fff;\n  padding: 5px;\n  font-size: 14px;\n}\n\n.c-select-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.c-select {\n  padding: 10px;\n  padding-left: 10px;\n  padding-right: 35px;\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  min-width: 150px;\n  height: 42px;\n  border: 1px solid #d0d0d0;\n  color: #605f5fdd;\n  font-size: 14px;\n  appearance: none;\n  cursor: pointer;\n}\n\n/* Adds a custom dropdown icon */\n.c-select-wrapper::after {\n  content: \"▼\"; /* Unicode down arrow */\n  font-size: 12px;\n  color: #888;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.c-select:focus {\n  border-color: #1cb8fb;\n  border-width: 2px;\n  outline: none;\n}\n\n.c-select option {\n  background-color: #fff;\n  color: #333;\n}\n\n.flex-multi-select {\n  font-size: small;\n  border-radius: 8px;\n  background-color: #fff;\n  width: 100%;\n}\n.flex-multi-select:focus {\n  border-color: #1cb8fb !important;\n  border-width: 2px;\n}\n.css-1pahdxg-control:hover {\n  border-color: #1cb8fb !important;\n}\n\n.css-1pahdxg-control {\n  box-shadow: 0 0 0 2px #9ee5f7 !important;\n  border-color: #1cb8fb !important;\n}\n\n.rounded-pricing-img {\n  width: 70px;\n  height: 70px;\n  border-radius: 24%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ecf3ff;\n}\n\n.custom-upload-button {\n  border: 1px dashed blue;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  background-color: #f9f9f9;\n}\n\n.plan-badge {\n  background-color: #c1fac1;\n  border-radius: 6px;\n  padding: 8px;\n  color: green;\n  font-weight: 400;\n}\n\n.cus-hr {\n  width: 150px;\n}\n\n.ticket-image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  margin-right: 8px;\n  border: 1px solid grey;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.c-title {\n  color: #0088ff;\n}\n\n.min-guage {\n  display: flex;\n  justify-content: space-between;\n  font-size: 10px;\n  padding: 0 2px;\n}\n\n.home-btn {\n  width: 60px;\n  height: 60px;\n  background-color: #fff !important;\n  border-radius: 50%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.home-btn:hover {\n  transform: scale(1.15);\n  background-color: #0277bd;\n}\n.c-notification-form-control .c-radio-margin {\n  margin-left: 16px;\n}\n\n@media (min-width: 768px) {\n  .c-notification-form-control .c-radio-margin {\n    margin-left: 0px;\n  }\n}\n.c-notification-form-control .c-radio-margin {\n  margin-left: 0px;\n}\n\n.c-pl {\n  padding-left: 20px;\n}\n\n.c-img {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.c-choose-li {\n  position: relative;\n  padding-left: 40px;\n  margin-bottom: 16px;\n  font-size: 1.25rem;\n  line-height: 1.6;\n  color: #344767;\n  transition: all 0.3s ease;\n  cursor: default;\n}\n\n.c-choose-li:hover {\n  color: #17ad37;\n  transform: translateX(5px);\n}\n\n.c-choose-icon {\n  position: absolute;\n  left: 0;\n  top: 4px;\n  font-size: 1.5rem;\n  color: #17ad37;\n}\n\n.logo-slide-1 {\n  opacity: 1;\n  transform: none;\n  max-width: 100px;\n  position: absolute;\n  right: 20px;\n  bottom: 10px;\n}\n@media (max-width: 768px) {\n  .slick-slide img.logo-slide-1 {\n    display: none;\n  }\n}\n\n.list-none {\n  list-style-type: none;\n}\n\n.signature-canvas {\n  border: 1px solid #ccc;\n  background-color: #fff;\n  display: block;\n}\n/* fullcalendar styles */\n\n.fc-toolbar button {\n  background-color: #1976d2;\n  color: white;\n  border-radius: 4px;\n  padding: 6px 12px;\n  margin-right: 6px;\n  border: none;\n  font-weight: bold;\n}\n\n.fc-toolbar .fc-toolbar-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #444;\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 16px;\n}\n\n.event-danger {\n  color: red;\n}\n\n.event-green {\n  color: green;\n}\n\n.c-table {\n  border-collapse: separate;\n   border-spacing: 0 8px;\n}\n\n.c-table-head {\n  background: rgba(0,0,0,0.02);\n  border-bottom: 1px solid #c6c6c6;\n}\n\n.c-table-p-0{\n  padding: 4px;\n}\n\n.c-video-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height:100%;\n  object-fit: contain ;\n  background: black;\n}\n\n.activity-link {\n  width: fit-content;\n  text-decoration: none;  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
